import _ from "@lodash";
import { Checkbox, Drawer, InputAdornment, MenuItem, Popover, TextField, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import { StringDateUSToBR } from "app/Core/Helpers";
import withReducer from "app/store/withReducer";
import clsx from "clsx";
import history from "history.js";
import Constante from "Constante.json";
import Cookies from "js-cookie";
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import * as Actions from "./Store/Actions/AgendaPainelActions";
import reducer from "./Store/Reducers/AgendaPainelReducer";
import Loading from "@fuse/components/FuseLoadable/Loading";
import AgendamentoEdicaoApp from "app/CRM/AgendamentoEdicao/AgendamentoEdicaoApp";

const styles = theme => ({
    root: {
        padding: 8,
        width: "85%",
        "@media (min-width: 1280px)": {
            width: 600,
        }
    },
    card: {
        background: theme.palette.type === "dark" ? "#303030" : "#FFF",
        borderRadius: 5
    },
    seletorTipo: {
        "& input": {
            "cursor": "pointer"
        },
    },
});

class AgendaPainel extends XAPPComponent {

    state = {
        inicio: new Date().toISOString().substring(0, 10),
        termino: new Date().toISOString().substring(0, 10),
        tipos: [],
        updated: 0,
        menuEl: null,
        componente: null,
    }

    componentDidMount() {
        if (!_.isUndefined(Cookies.get("agendaPainelTipos")) && Cookies.get("agendaPainelTipos").length > 0) {
            this.setState(_.set({ ...this.state }, "tipos", Cookies.get("agendaPainelTipos").split(",").map(Number)));
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { AgendaReducer, empresa = null, list, sistemas = null } = this.props;

        if (AgendaReducer.open && !_.isEqual(prevProps.AgendaReducer.open, AgendaReducer.open) &&
            !_.isEqual(this.state.inicio, new Date().toISOString().substring(0, 10))) {
            this.setState(Object.assign({}, { inicio: new Date().toISOString().substring(0, 10), termino: new Date().toISOString().substring(0, 10) }, this.state));
        }

        if (!AgendaReducer.open && !_.isEqual(prevProps.AgendaReducer.open, AgendaReducer.open)) {
            let NewState = {
                inicio: new Date().toISOString().substring(0, 10),
                termino: new Date().toISOString().substring(0, 10),
                tipos: []
            };
            if (!_.isUndefined(Cookies.get("agendaPainelTipos")) && Cookies.get("agendaPainelTipos").length > 0) {
                Cookies.get("agendaPainelTipos").split(",").forEach(item => {
                    NewState.tipos.push(Number(item));
                });
            }
            else {
                if (!_.isNull(AgendaReducer.tipos)) {
                    AgendaReducer.tipos.forEach(item => {
                        NewState.tipos.push(Number(item.tipo));
                    });
                }
            }
            this.setState(NewState);
        }

        if (!_.isNull(empresa) && _.isNull(prevProps.empresa) && this.state.updated === 0) {
            this.pesquisar(false);
            this.setState(_.set({ ...this.state }, "updated", 1));
        }

        if (!_.isNull(AgendaReducer.tipos) && !_.isEqual(AgendaReducer.tipos, prevProps.AgendaReducer.tipos) &&
            this.state.updated === 1 && this.state.tipos.length === 0) {
            let ATipos = [];
            AgendaReducer.tipos.forEach(item => {
                ATipos.push(Number(item.tipo));
            });
            this.setState(_.set({ ...this.state }, "tipos", ATipos));
        }
    }

    getDados = () => {
        const { AgendaReducer } = this.props;
        const form = this.state;
        let AResponse = [];
        if (!_.isUndefined(AgendaReducer.data) && !_.isNull(AgendaReducer.data)) {
            AResponse = AgendaReducer.data;
        }
        AResponse = _.sortBy(AResponse, [function (o) { return o.ordenacao; }]);
        return AResponse;
    }

    handleChange = ev => {
        this.setState(_.set({ ...this.state }, ev.target.name, ev.target.value));
    }

    handleChangeTipos = _AID => {
        let ATipos = [];
        if (this.state.tipos.includes(_AID)) {
            this.state.tipos.forEach(item => {
                if (item !== _AID) {
                    ATipos.push(item);
                }
            });
        }
        else {
            ATipos = [...this.state.tipos];
            ATipos.push(_AID);
        }
        this.setState(_.set({ ...this.state }, "tipos", ATipos));
    }

    handleChangeFavoritos = _AID => {
        let ATipos = [];
        let ACookie = [];
        if (!_.isUndefined(Cookies.get("agendaPainelTipos")) && Cookies.get("agendaPainelTipos").length > 0) {
            ACookie = Cookies.get("agendaPainelTipos").split(",").map(Number);
        }
        if (ACookie.includes(_AID)) {
            ACookie.forEach(item => {
                if (item !== _AID) {
                    ATipos.push(item);
                }
            });
        }
        else {
            ATipos = [...ACookie];
            ATipos.push(_AID);
        }

        Cookies.set("agendaPainelTipos", ATipos.join(","));
        this.setState(_.set({ ...this.state }, "tipos", _.uniq([...this.state.tipos, ...ATipos])));
    }

    getCountAll = () => {
        const { AgendaReducer } = this.props;
        const { tipos } = this.state;
        let AResponse = 0;
        !_.isNull(AgendaReducer.tipos) && AgendaReducer.tipos.map(item => {
            if (tipos.includes(item.tipo)) {
                AResponse += item.total;
            }
        });
        return AResponse;
    }

    getUrlWhatsApp = (_AItem, _ATipo) => {
        if (!_.isUndefined(_AItem.whatsapp) && !_.isNull(_AItem.whatsapp) && _AItem.whatsapp.length > 0) {
            var AFone = _AItem.whatsapp;
            switch (_ATipo) {
                case 5: return `https://api.whatsapp.com/send?phone=${AFone}&text=${this.getMessageAniversario()}`;
                default: return `https://wa.me/${AFone}`;
            }
        }
        else {
            return "";
        }
    }

    getUrlEmail = (_AItem, _ATipo) => {
        let ATitulo = "Aniversariante";
        const { sistemas = null, empresa = null } = this.props;

        if (!_.isUndefined(sistemas[empresa].dados.configuracao)) {
            let AConfig = _.find(sistemas[empresa].dados.configuracao, { "chave": "ANIVERSARIANTE_TITULO" });
            if (!_.isUndefined(AConfig)) {
                ATitulo = AConfig.valor;
            }
        }

        if (!_.isUndefined(_AItem.email) && !_.isNull(_AItem.email) && _AItem.email.length > 0) {
            switch (_ATipo) {
                case 5: return `mailto:${_AItem.email}?subject=${ATitulo}&body=${this.getMessageAniversario()}`;
                default: return `mailto:${_AItem.email}`;
            }
        }
        else {
            return "";
        }
    }

    getMessageAniversario = () => {
        let AResponse = Constante.mensagem_aniversariante;
        const { sistemas = null, empresa = null } = this.props;

        if (!_.isUndefined(sistemas[empresa].dados.configuracao)) {
            let AConfig = _.find(sistemas[empresa].dados.configuracao, { "chave": "ANIVERSARIANTE" });
            if (!_.isUndefined(AConfig)) {
                AResponse = AConfig.valor;
            }
        }
        AResponse = AResponse.replace("<#EMPRESA#>", (!_.isNull(sistemas[empresa].nomesocial) && sistemas[empresa].nomesocial.length > 0 ? sistemas[empresa].nomesocial : sistemas[empresa].nome));

        return AResponse;
    }

    getComponente = (item, x) => {
        const { empresa = null } = this.props;
        switch (item.acao.componente) {
            case "agendamento": return (
                <AgendamentoEdicaoApp
                    className="w-full"
                    xappRouteParams={{ empresa: empresa }}
                    view={"Default"}
                    isDialog={true}
                    tipo={item.acao.tipo}
                    idagendamento={item.acao.id}
                    openContent={item.acao.tab}
                    key={"Agendamento_EdicaoPainel"}
                    callback={this.pesquisar}
                >
                    {this.getCard(item, x)}
                </AgendamentoEdicaoApp>
            );
            default:
                return (
                    <React.Fragment>
                        {this.getCard(item, x)}
                    </React.Fragment>
                );
        }
    }

    getCard = (item, x) => {
        const { classes, toggleAgenda, AgendaReducer, sistemas = null, empresa = null } = this.props;
        let AAtual = null;
        let ATipo = _.find(AgendaReducer.tipos, { tipo: item.tipo });
        let ABackgroud = item.cor;

        if (_.isNull(AAtual) && new Date(item.prazo) >= new Date()) {
            AAtual = item;
            ABackgroud = "#FFFFBF";
        }
        return (
            <React.Fragment>
                <div
                    key={"Item_" + new Date().getTime()}
                    className={clsx(classes.card, "w-full border-1 p-4 mb-8", item.rota.length > 0 && "cursor-pointer")}
                    style={{ backgroundColor: ABackgroud }}
                    onClick={() => {
                        if (item.rota.length > 0) {
                            history.push(item.rota.replace("<#ORGANIZACAO#>", sistemas[empresa].organizacao).replace("<#EMPRESA#>", empresa) + "&c=" + new Date().getTime());
                            toggleAgenda();
                        }
                    }}
                >
                    <div className="flex flex-row items-center w-full">
                        <XAPPButton
                            className="p-6 max-h-32 mr-8"
                            onClick={() => { }}
                            type="icon"
                            noHover={true}
                            icon={!_.isUndefined(ATipo) ? ATipo.tipoicone : ""}
                            iconProps={"text-20 text-black"}
                        />
                        <Typography className="w-full leading-loose text-black">{!_.isUndefined(ATipo) ? ATipo.tiponome : ""}</Typography>
                        <Typography className="min-w-128 leading-loose text-black">{StringDateUSToBR(item.prazo).replace("00:00", "")}</Typography>
                    </div>
                    <div className="flex flex-row items-center w-full">
                        <Typography className="w-full leading-loose px-6 text-black">{item.descricao}</Typography>
                        {!_.isUndefined(ATipo) && this.getUrlWhatsApp(item, ATipo.tipo).length > 0 &&
                            <XAPPButton
                                className="p-6 max-h-32 mr-8"
                                onClick={ev => ev.stopPropagation()}
                                href={this.getUrlWhatsApp(item, ATipo.tipo)}
                                component={"a"}
                                target={"_blank"}
                                type="icon"
                                icon={"whatsapp"}
                                iconProps={"text-20 text-green"}
                            />
                        }
                        {!_.isUndefined(ATipo) && this.getUrlEmail(item, ATipo.tipo).length > 0 &&
                            <XAPPButton
                                className="p-6 max-h-32 mr-8"
                                onClick={ev => ev.stopPropagation()}
                                href={this.getUrlEmail(item, ATipo.tipo)}
                                component={"a"}
                                target={"_blank"}
                                type="icon"
                                icon={"email"}
                                iconProps={"text-20 text-yellow-dark"}
                            />
                        }
                    </div>
                </div>
            </React.Fragment>
        );
    }

    pesquisar = (_AOpen = true) => {
        const { sistemas = null, empresa = null, list } = this.props;
        const form = this.state;
        list({ empresa: empresa, organizacao: sistemas[empresa].organizacao }, form, _AOpen);
    }

    render() {
        const { classes, toggleAgenda, AgendaReducer, sistemas = null, empresa = null } = this.props;
        const form = this.state;
        const AArray = this.getDados();
        return (
            <React.Fragment>
                {!_.isNull(sistemas) && !_.isNull(empresa) && !_.isNull(sistemas[empresa]) &&
                    <XAPPButton
                        className=""
                        onClick={() => {
                            toggleAgenda();
                            this.pesquisar();
                        }}
                        type="icon"
                        icon={this.getCountAll() > 0 ? "notify" : "no_notify"}
                        iconProps={"text-20"}
                        badge={this.getCountAll()}
                    />
                }
                <Drawer
                    classes={{ paper: classes.root }}
                    open={AgendaReducer.open}
                    anchor={"right"}
                    onClose={() => toggleAgenda()}
                >
                    <div className="flex">
                        <div className="flex-1" />
                        <XAPPButton
                            className="p-6"
                            onClick={() => toggleAgenda()}
                            type="icon"
                            icon={"close"}
                            iconProps={"text-20"}
                        />
                    </div>
                    <div className="flex flex-row w-full items-center">
                        <TextField
                            className="mb-12 w-full mr-8"
                            label="Início"
                            id="inicio"
                            name="inicio"
                            value={form.inicio}
                            onChange={this.handleChange}
                            //variant="outlined"
                            fullWidth
                            type="date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <TextField
                            className="mb-12 w-full"
                            label="Término"
                            id="termino"
                            name="termino"
                            value={form.termino}
                            onChange={this.handleChange}
                            //variant="outlined"
                            fullWidth
                            type="date"
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                        <div className="flex-1" />
                        <XAPPButton
                            className="p-6 max-h-32 ml-8"
                            onClick={() => this.pesquisar()}
                            type="icon"
                            icon={"search"}
                            iconProps={"text-20"}
                        />
                    </div>
                    <div className="flex flex-row w-full items-center">
                        <TextField
                            className={clsx(classes.seletorTipo, "mb-12 w-full mr-8")}
                            onClick={ev => {
                                this.setState(_.set({ ...this.state }, "menuEl", ev.currentTarget));
                                ev.target.blur();
                            }}
                            label={"Tipos [ " + form.tipos.length + " ]"}
                            id="tipos"
                            name="tipos"
                            fullWidth
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <XAPPButton
                                            className="p-6 max-h-32 "
                                            onClick={ev => { }}
                                            type="icon"
                                            noHover={true}
                                            icon={"arrow_down"}
                                            iconProps={"text-20"}
                                        />
                                    </InputAdornment>
                                )
                            }}
                        />
                        <Popover
                            id="financeitoReceberMenu"
                            anchorEl={form.menuEl}
                            open={Boolean(form.menuEl)}
                            onClose={ev => this.setState(_.set({ ...this.state }, "menuEl", null))}
                        >
                            {!_.isNull(AgendaReducer.tipos) && AgendaReducer.tipos.map(item => (
                                <MenuItem key={"Item_" + item.tipo} className="flex items-center px-6">
                                    <Checkbox
                                        checked={form.tipos.includes(item.tipo)}
                                        color="inherit"
                                        className={"p-6"}
                                        onClick={() => this.handleChangeTipos(item.tipo)}
                                    />
                                    {item.tiponome + " [ " + (!_.isNull(AgendaReducer.data) && AgendaReducer.data.length > 0 ? _.filter(AgendaReducer.data, { tipo: item.tipo }).length : item.total) + " ] "}
                                    <div className="flex-1" />
                                    <XAPPButton
                                        className="p-6 ml-8 max-h-32"
                                        onClick={ev => this.handleChangeFavoritos(item.tipo)}
                                        type="icon"
                                        icon={!_.isUndefined(Cookies.get("agendaPainelTipos")) && Cookies.get("agendaPainelTipos").split(",").map(Number).includes(item.tipo) ? "star" : "no_star"}
                                        iconProps={"text-18"}
                                    />
                                </MenuItem>
                            ))}
                        </Popover>
                    </div>
                    {AgendaReducer.preload ?
                        <div className="py-128">
                            <Loading pastDelay={true} />
                        </div>
                        :
                        <React.Fragment>
                            {AArray.length > 0 ?
                                <div className="flex h-full overflow-hidden">
                                    <div className="flex flex-col w-full overflow-y-auto">
                                        {AArray.map((item, x) => (
                                            <React.Fragment>
                                                {!_.isNull(item.acao) ?
                                                    this.getComponente(item, x)
                                                    :
                                                    this.getCard(item, x)
                                                }
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </div>
                                :
                                <div className="flex flex-col flex-1 items-center justify-center text-center p-16">
                                    <Typography variant="h5" color="textSecondary" className="mb-16">
                                        {"Não existem tarefas pendentes!"}
                                    </Typography>
                                </div>
                            }
                        </React.Fragment>
                    }
                </Drawer>
            </React.Fragment >
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        toggleAgenda: Actions.toggleAgenda,
        list: Actions.list,
    }, dispatch);
}

function mapStateToProps({ AgendaReducer, auth, fuse }) {
    return {
        AgendaReducer: AgendaReducer,
        sistemas: auth.user.data.settings.sistemas,
        empresa: fuse.navigation.empresa,
        theme: fuse.settings.mainTheme,
    }
}

export default withReducer("AgendaReducer", reducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(AgendaPainel))));
